import { ref } from 'vue';

// Shared "open the mobile search pill" request.
//
// The bottom-bar Search action lives in MobileMenu, but the pill itself is
// rendered by whichever view owns the header row (LeagueHeader on betting
// pages, the filter row on the homepage). Using a monotonic counter instead
// of a fire-and-forget event (or a sticky boolean) makes the hand-off robust:
//   - a view still loading (header not mounted yet) picks the request up via
//     an `immediate` watch once it mounts,
//   - every tap bumps the counter, so repeat taps re-trigger watchers even
//     while an earlier request is still outstanding,
//   - a request that no view consumes (e.g. a view that failed to load, or a
//     route with no pill) stays "pending", which callers detect and handle by
//     routing to a working search surface.
export const mobileSearchRequest = ref(0);
let lastConsumed = 0;

export function requestMobileSearch() {
  mobileSearchRequest.value += 1;
}

// Returns true (and marks the latest request consumed) only when there's an
// unconsumed request, so a single tap opens exactly one pill.
export function consumeMobileSearch() {
  if (mobileSearchRequest.value === lastConsumed) return false;
  lastConsumed = mobileSearchRequest.value;
  return true;
}

export function isMobileSearchPending() {
  return mobileSearchRequest.value !== lastConsumed;
}

// Whether a mobile search pill is currently open, shared so the bottom bar can
// show its active "box" on the Search icon while searching — regardless of
// which view (homepage filter row or LeagueHeader) actually owns the pill.
export const mobileSearchOpen = ref(false);
export function setMobileSearchOpen(open) {
  mobileSearchOpen.value = open;
}
